import { render, staticRenderFns } from "./PatientEduRes.vue?vue&type=template&id=36adfc1c&"
import script from "./PatientEduRes.vue?vue&type=script&lang=js&"
export * from "./PatientEduRes.vue?vue&type=script&lang=js&"
import style0 from "./PatientEduRes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports